module.exports = __webpack_public_path__ + "media/images/stripe/light-on-light-9892557b547184c4577a782b15403753.png";